import { useState, useEffect, useRef } from "react";
import ConfigRouter from "./components/ConfigRouter";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Loading from "./pages/Loading";

function App() {
    const [loaded, setLoaded] = useState(false);
    const timerShowWeb = useRef();

    useEffect(() => {
        const showWebContent = () => {
            timerShowWeb.current = setTimeout(() => {
                setLoaded(true);
            }, 2000);
        };

        window.addEventListener("load", showWebContent);

        return () => {
            clearTimeout(timerShowWeb);
            window.removeEventListener("load", showWebContent);
        };
    }, [loaded]);

    return (
        <>
            {loaded ? (
                <div className="container">
                    <Header />
                    <ConfigRouter />
                    <Footer />
                </div>
            ) : (
                <Loading />
            )}
        </>
    );
}

export default App;
